import React from 'react';
import ReportGroupManagementRouter from './ReportGroupManagementRouter';

export default function ReportGroupManagementPage() {
  return <ReportGroupManagementRouter />;
}
